<template>
  <v-card flat>
    <v-card-text>
      <v-container fluid>
        <v-row dense> 
          <v-col cols="4">
            <v-row dense> 
              <v-col cols="6">
                <v-text-field v-model="editedItem.id" :label="prodottoBase ? 'Id Prodotto Master' : 'Id Prodotto'"></v-text-field>
              </v-col>          
              <v-col cols="6">
                <v-text-field v-model="editedItem.sku" label="SKU Prodotto" readonly></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="editedItem.nome" label="Nome" readonly></v-text-field>
              </v-col>              
              <v-col cols="12">
                <v-text-field v-model="editedItem.url" label="Url accesso diretto" readonly></v-text-field>
              </v-col>
              <v-col cols="4" v-if="!prodottoBase">
                <v-text-field v-model="editedItem.listino" label="Listino" :rules="[numerico]" readonly></v-text-field>
              </v-col> 
              <v-col cols="4">
                <v-text-field v-model="editedItem.prezzo" label="Prezzo" :rules="[numerico]" class="text-h5" readonly></v-text-field>
              </v-col>                                            
              <v-col cols="4" v-if="!prodottoBase">
                <v-text-field v-model="editedItem.offerta" label="Offerta" :rules="[numerico]" readonly></v-text-field>
              </v-col> 
              <v-col cols="4" v-if="!prodottoBase">
                <v-text-field v-model="editedItem.giacenzaWeb" label="Giacenza WEB" :rules="[numerico]" class="text-h5" type="number" readonly></v-text-field>
              </v-col>
              <v-col cols="4" v-if="!prodottoBase">
                <v-text-field v-model="editedItem.giacenzaPrincipale" label="Giacenza principale" :rules="[numerico]" readonly></v-text-field>
              </v-col>              
              <v-col cols="12" sm="4"> 
                <v-switch v-model="editedItem.abilita" inset label="Prodotto attivo"></v-switch>
              </v-col>
<!--               <v-col cols="12">
                <v-text-field v-if="!prodottoBase" v-model="nuovaGiacenza" label="Nuova giacenza WEB" :rules="[numerico]" class="text-h5" type="number"></v-text-field>
                <v-btn v-if="!prodottoBase" color="info" @click="modificaGiacenzaWeb">Modifica giacenza Web</v-btn> -->
<!--                 <v-btn v-if="!prodottoBase" color="info" @click="diminuisceGiacenza">Diminuisci giacenza</v-btn>
                <v-btn v-if="!prodottoBase" color="success" class="ml-5" @click="aumentaGiacenza">Aumenta giacenza</v-btn> -->
              <!-- </v-col> -->
              <v-col cols="12" v-if="prodottoBase">
                <span class="mt-5 text-subtitle-2 font-weight-bold red--text text--lighten-1">Il prodotto Master permette di configurare le caratteristiche del prodotto. Si veda il dettaglio delle varianti per configurare le rispettive giacenze e prezzi</span>   
              </v-col>                
            </v-row>
            <v-row dense v-if="!prodottoBase" class="mt-5">
              <v-col>
                <v-text-field v-model="nuovaGiacenza" label="Nuova giacenza Web" :rules="[numerico]" class="text-h5" type="number"></v-text-field>
              </v-col>
              <v-col>  
                <v-btn color="info" class="mt-3" @click="modificaGiacenzaWeb">Modifica giacenza Web</v-btn>
              </v-col>
            </v-row>
            <v-row dense v-if="!prodottoBase" class="mt-5">
              <v-col>
                <v-text-field v-model="nuovoPrezzo.prezzo" label="Nuovo prezzo Web" :rules="[numerico]" class="text-h5" type="number"></v-text-field>
                <v-text-field v-model="nuovoPrezzo.listino" label="Nuovo prezzo listino Web" :rules="[numerico]" class="text-h5" type="number"></v-text-field>
                <v-text-field v-model="nuovoPrezzo.offerta" label="Nuovo prezzo offerta Web" :rules="[numerico]" class="text-h5" type="number"></v-text-field>
              </v-col>
              <v-col>  
                <v-btn color="info" class="mt-3" @click="modificaPrezziWeb">Modifica prezzi Web</v-btn>
              </v-col>
            </v-row>            
          </v-col>
          <v-col cols="1"></v-col>
          <v-col cols="7" v-if="editedItem.descrizione">
            <!-- eslint-disable -->
            <v-textarea v-html="editedItem.descrizione" style="max-width:30vw;"></v-textarea>
            <!-- eslint-enable -->
          </v-col>
          <v-col cols="3" v-else>
            <v-img :src="editedItem.immagine" max-height="300" contain/>
            <v-text-field v-if="prodottoBase" :value="varianti" label="Varianti" readonly></v-text-field>
            <v-text-field v-if="prodottoBase" :value="opzioni" label="Opzioni" readonly></v-text-field>
          </v-col>          
        </v-row>
        <v-row dense v-if="editedItem.descrizione">  
          <v-col cols="6"></v-col>
          <v-col cols="3">
            <v-img :src="editedItem.immagine" max-height="300" contain/>
            <v-text-field v-if="prodottoBase" :value="varianti" label="Varianti" readonly></v-text-field>
            <v-text-field v-if="prodottoBase" :value="opzioni" label="Opzioni" readonly></v-text-field>
          </v-col>
        </v-row> 
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="info" @click="aggiornaInfo" :loading="loading" :disabled="loading">Aggiorna dal sito</v-btn>
      <v-btn color="success" class="mr-5" :disabled="disabilitaSave" @click="salvaModifiche">Salva</v-btn>
    </v-card-actions>    
  </v-card>  
</template>

<script>
  import _ from 'lodash'
  import { calcolaHash, delay } from '@/components/helpers'
  import eCommerce from '@/services/eCommerceService'
  import configurazioni from '@/services/configurazioniService.js'

  export default {
    props: {
      item: Object,
      refresh: Number
    },
    data () {
      return {
        tabs: null,
        updateTrigger: 1,
        numerico: value => !value || !isNaN(value) || 'Il valore deve essere numerico',
        editedItem: {
          id: '',
          url: '',
          abilita: true,
          sku: '',
          descrizione:'',
          prezzo: null,
          giacenza: null,
          giacenzaWeb: null,
          giacenzaPrincipale: null
        },
        savedHash: '',
        loading: false,
        impostazioni: null,
        sincronizzaPrezzi: 'none', // webtoubi, ubitoweb, none
        sincronizzaGiacenza: 'none',
        forzaSave: false,
        magazzinoWeb: 'mag01',
        gestioneSeparataStockVarianti: false, // lo stock è gestito separatamente per le varianti ?
        nuovaGiacenza: '',
        nuovoPrezzo: {
          prezzo: '',
          listino: '',
          offerta: ''
        }
      }
    },
    watch: {
      async refresh() {
        this.savedHash = calcolaHash(this.item.eCommerce)
      }
    },
    async mounted() {
      this.impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.magazzinoWeb = _.get(this.impostazioni, 'eCommerce.magazzino', 'mag01')
      this.sincronizzaPrezzi = _.get(this.impostazioni, 'eCommerce.sincronizzaPrezzi', 'none')
      this.sincronizzaGiacenza = _.get(this.impostazioni, 'eCommerce.sincronizzaGiacenza', 'none')
      this.gestioneSeparataStockVarianti = _.get(this.impostazioni, 'eCommerce.gestioneSeparataStockVarianti', false)
      // se il prodotto non ha varianti --> forza false
      this.gestioneSeparataStockVarianti = this.gestioneSeparataStockVarianti && _.get(this.item, 'eCommerce.prodottoConVarianti', false)
      this.savedHash = calcolaHash(this.item.eCommerce)
      this.editedItem = this.item.eCommerce
      this.editedItem.giacenzaWeb = this.calcolaGiacenza(this.item, this.magazzinoWeb)
      this.editedItem.giacenzaPrincipale = this.calcolaGiacenza(this.item)
      // Da impostazioni --> sincronizza prezzi e giacenze con prodotto: web --> gestionale o gestionale --> web o nessuna sincronizzazione
      
    },
    computed: {
      disabilitaSave() {
        return this.savedHash === calcolaHash(this.editedItem) && !this.forzaSave
      },
      varianti() {
        return this.editedItem && this.editedItem.variazioni && this.editedItem.variazioni.join(', ')
      },
      opzioni() {
        return this.editedItem && this.editedItem.attributi && this.editedItem.attributi.join(', ')
      },
      prodottoConVarianti() {
        return this.editedItem.prodottoConVarianti
      },
      prodottoBase() {
        return this.editedItem.prodottoBase || (this.editedItem.prodottoConVarianti && this.editedItem.tipo === 'variable')
      },
      magazziniMultipli() {
        return this.$store.getters['magazzini/magazziniMultipli']
      },
      magazzinoSelezionato() {
        return this.$store.getters['magazzini/codiceMagazzino']
      }      
    },
    methods: {   
      async aggiornaInfo() {
        // legge dal sito --> procedura generale che viene separata in base al tipo di ecommerce del prodotto
        // al limite il tipo può essere su ciascun prodotto --> più ecommerce disponibili ... (anche stesso prodotto su più ecommerce ...!!!)
        // calcola hash, se diverso richiede aggioramento in locale
        this.loading = true
        const infoProdotto = await eCommerce.getInfoProdotto(this.editedItem.id)
        this.editedItem = infoProdotto
        this.item.eCommerce = infoProdotto
        // if (this.sincronizzaPrezzi === 'webtoubi') { // Tolto: Se seleziono aggiorna dal sito, deve aggiornare, indipendentemente dalle impostazioni
          const listinoWeb = _.get(this.impostazioni, 'eCommerce.listino', 'L1')
          const varPrezzo = _.get(this.impostazioni, 'eCommerce.variabilePrezzo', 'prezzo')
          const pzOld = _.get(this.item, 'prezzo[' + listinoWeb + '].base')
          _.set(this.item, 'prezzo[' + listinoWeb + '].base',  parseFloat(infoProdotto[varPrezzo] || 0))
          if (pzOld !== parseFloat(infoProdotto[varPrezzo])) {
            this.forzaSave = true
          }
        // }
        // if (this.sincronizzaGiacenza === 'webtoubi') {  // Tolto: Se seleziono aggiorna dal sito, deve aggiornare, indipendentemente dalle impostazioni
          const varGiacenza = _.get(this.impostazioni, 'eCommerce.variabileGiacenza', 'giacenza')
          _.set(this.item, 'magazzino.giacenzaParziale[' + this.magazzinoWeb + '].giacenza',  parseFloat(infoProdotto[varGiacenza] || 0))
          _.set(this.item, 'magazzino.giacenzaParziale[' + this.magazzinoWeb + '].valore',  parseFloat(infoProdotto[varGiacenza] || 0) * _.get(this.item, 'magazzino.prezzoAcquisto', 0))
          const giacenza = this.calcolaGiacenzaProdotto(_.get(this.item, 'magazzino.giacenzaParziale'))
          const gcOld = _.get(this.item, 'magazzino.giacenza')
          _.set(this.item, 'magazzino.giacenza', giacenza)
          _.set(this.item, 'magazzino.valore', giacenza * _.get(this.item, 'magazzino.prezzoAcquisto', 0))
          if (gcOld !== giacenza) {
            this.forzaSave = true
          }
        // }
        this.editedItem.giacenzaWeb = this.calcolaGiacenza(this.item, this.magazzinoWeb)
        this.editedItem.giacenzaPrincipale = this.calcolaGiacenza(this.item)        
        // this.savedHash = calcolaHash(this.editedItem)
        this.loading = false
/*         if (calcolaHash(this.editedItem) !== this.savedHash) {
          this.salvaModifiche()
        } */
      },
      calcolaGiacenzaProdotto(giacenzaParziale) {
        let tot = 0
        let gp = giacenzaParziale
        for (let g of Object.keys(gp)) {
          tot += gp[g].giacenza
        }
        return tot
      },
      salvaModifiche() {
        this.$emit('aggiorna', this.item)
        this.forzaSave = false
      },
      async diminuisceGiacenza() {
        // NON USATA
        //TODO: Andrebbe gestito l' aggiornamento in locale e l'eventuale eCommerce come update da Prodotti
        // in modo che sia sempre allineata la giacenza tra locale ed eCommerce
        // Verificare se ritorna Webhook aggiornamento prodotto  
        const giacenza = this.editedItem.giacenzaWeb || 0
        if (giacenza > 1) {
          await eCommerce.aggiornaGiacenzaProdotto(this.item, giacenza - 1, this.gestioneSeparataStockVarianti)
        }
      },
      async aumentaGiacenza() {
        // NON USATA
        //TODO: Andrebbe gestito l' aggiornamento in locale e l'eventuale eCommerce come update da Prodotti
        // in modo che sia sempre allineata la giacenza tra locale ed eCommerce
        // Verificare se ritorna Webhook aggiornamento prodotto
        const giacenza = this.editedItem.giacenzaWeb || 0
        await eCommerce.aggiornaGiacenzaProdotto(this.item, giacenza + 1, this.gestioneSeparataStockVarianti)
      },
      async modificaGiacenzaWeb() {
        if (!this.nuovaGiacenza) return // Lo zero deve essere ammesso
        const giacenza = parseFloat(this.nuovaGiacenza || 0)
        this.loading = true
        await eCommerce.aggiornaGiacenzaProdotto(this.item, giacenza, this.gestioneSeparataStockVarianti)
        await delay(1000)
        await this.aggiornaInfo()
        this.salvaModifiche()
        this.nuovaGiacenza = ''
      },
      async modificaPrezziWeb() {
        if (!(this.nuovoPrezzo.prezzo + this.nuovoPrezzo.listino + this.nuovoPrezzo.giacenza)) return
        this.loading = true
        await eCommerce.aggiornaPrezziProdotto(this.item, this.nuovoPrezzo, this.gestioneSeparataStockVarianti)
        await delay(1000)
        await this.aggiornaInfo()
        this.salvaModifiche()
        this.nuovoPrezzo = {
          prezzo: '',
          listino: '',
          giacenza: ''
        }
      },
      calcolaGiacenza(item, magazzino) {
        const giacenza = _.get(item, 'magazzino.giacenza', 0)
        if (!this.magazziniMultipli) {
          return giacenza
        } else {
          const giacenzaParziale = _.get(item, 'magazzino.giacenzaParziale', 0)
          if (typeof giacenzaParziale === 'object' && !_.isEmpty(giacenzaParziale)) {
            const gg = giacenzaParziale[magazzino || this.magazzinoSelezionato] || {}
            return gg.giacenza || 0
          } else {
            return this.magazzinoSelezionato === 'mag01' ? giacenza : 0
          }
        }
      },
      giacenzaTotale(item) {
        return `Giacenza totale: ${item.magazzino.giacenza || 0}`
      }      
    }
  }
</script>

<style lang="scss" scoped>
  .v-input {
    font-size: 14px;
  }
  thead {
    background-color: rgb(222, 228, 233);
  }
  .manuale {
    background-color: rgb(193, 241, 183);
  }
  .mancanzaValore {
    color: red;
  }
</style>
